import React, { useEffect } from 'react';
import facebook from "../../common/media/facebook.svg";
import instagram from "../../common/media/instagram.svg";
import twitter from "../../common/media/twitter.svg";
import logo from "../../common/media/cc_logo_white.svg";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useHistory } from "react-router-dom";
import ProjectsList from "../../common/components/Projects/ProjectsList";
import {trackAdditionalPageView} from "../../common/util/ccAnalyticsV2";
import { footerLinks } from '../../common/util/uiConfigs/footerConfiguration';


const LearnMorePage = ({ merchantCode, fetchedImpact }) => {

    const history = useHistory();

    useEffect(() => {
        //trackAdditionalPageView('MERCHANTNAME-learn-more-page');
    }, []);

    return (
        <div>
            <div className="h-85vh w-100 position-relative bg-primary vertical-align-parent color-white learn-more-img img-cover" >
                <div className="container vertical-align">
                    <div className="mobile-hide">
                        <div className="mb-2">
                            <img src="https://res.cloudinary.com/carbonclick/image/upload/v1613098599/Enterprise/Round%20Theory%20/Rt-Badge_yi3gpv.svg" />
                        </div>
                        <h1 className="mb-4 text-shadow mt-0">Round Theory's Wine is Now<br />Climate Positive!</h1>
                        <h3 className="mb-4 text-shadow">But what does that mean?</h3>
                    </div>
                    <div className="mobile-show">
                        <div className="mb-3">
                            <img src="https://res.cloudinary.com/carbonclick/image/upload/v1613098599/Enterprise/Round%20Theory%20/Rt-Badge_yi3gpv.svg" />
                        </div>
                        <h3 className="mb-3 text-shadow mt-0">Round Theory's Wine is Now Climate Positive!</h3>
                        <h3 className="mb-3 text-shadow">But what does that mean?</h3>
                    </div>
                </div>
            </div>

            <section className="p-3 text-center bg-primary">
                <div className="mobile-hide">
                    <div className="d-flex flex-row color-white w-fit center">
                        <div className="mr-3 mb-2">
                            <span className="font-bold">Climate positive by</span>
                        </div>
                        <div>
                            <a target="_blank" rel="noopener noreferrer" href={`https://carbonclick.com`}>
                                <img style={{ width: 200 }} className="cc-logo" src={logo} alt="carbonclick" />
                            </a>
                        </div>
                    </div>
                </div>
                <div className="mobile-show">
                    <div className="color-white center">
                        <div className="mb-2">
                            <span className="font-bold">Climate positive by</span>
                        </div>
                        <div>
                            <a target="_blank" rel="noopener noreferrer" href={`https://carbonclick.com`}>
                                <img style={{ width: 200 }} className="cc-logo" src={logo} alt="carbonclick" />
                            </a>
                        </div>
                    </div>
                </div>

            </section>

            <section className="py-5 mobile-py-3">
                <article className='container'>
                    <div className="center mw-800px">
                        <h2 className="font-bold color-primary mb-3">
                            What makes Round Theory<br />Climate Positive?
                        </h2>
                        <div>
                            <h4>
                                Round Theory have partnered with CarbonClick to make a great wine that is also good for the Earth.
                            </h4>
                            <br />
                            <h5>
                                Each bottle of Round Theory Wine is not only grown and sourced sustainably,  but we’re making sure that more - in fact, about double as much - carbon is offset with each bottle, making it climate positive. That means that with every bottle we ensure that about double the carbon footprint of the wine has been saved by funding some of the worlds best projects that fight climate change.
                            </h5>
                            <br />
                            <h5><b>But it goes further than that...</b></h5>
                            <br />
                            <h5>
                                <span>Round Theory wine is Vegan certified and is sourced from a Sustainable Winegrowing New Zealand™ (SWNZ) certified winery. As part of SWNZ, members continuously improve their practices are independently audited on six sustainability focus areas; Water, Waste, Pest and Disease, Soil, Climate Change and People. As part of long term sustainability goals, the Vinyards constantly implement new solutions and continue to reduce their environmental impact.</span>
                            </h5>
                            <br />
                            <img style={{ maxWidth: "720px", width: "100%" }} src="https://res.cloudinary.com/carbonclick/image/upload/v1613084275/Enterprise/Round%20Theory%20/rt-graph_efy5ky.png" />
                            <br />
                            <div style={{ textAlign: "left" }}>
                                <p className="font-bold">Sources:</p>
                                <ul className="color-primary font-bold">
                                    <li><a className="color-primary font-bold" rel="noopener noreferrer" href="https://mro.massey.ac.nz/bitstream/handle/10179/2920/02_whole.pdf" target="_blank">Massey University Study</a></li>
                                    <li><a className="color-primary font-bold" rel="noopener noreferrer" href="https://www.mdpi.com/2071-1050/11/10/2945/htm" target="_blank">State University of New York Study</a></li>
                                    <li><a className="color-primary font-bold" rel="noopener noreferrer" href="https://www.aidic.it/cet/14/39/100.pdf" target="_blank">AIDIC publication</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </article>
            </section>
            <section className="bg-secondary py-5 mobile-py-3" >
                <article>
                    <div className="container">
                        <div className="mw-800px center mobile-hide">
                            <div className="row">
                                <div className="col-6">
                                    <img style={{ maxHeight: '540px', width: '100%' }} className="image" src="https://res.cloudinary.com/carbonclick/image/upload/v1613084275/Enterprise/Round%20Theory%20/rt-2_uqekuk.png" />
                                </div>
                                <div className="col-6">
                                    <div className="p-5 text-left">
                                        <h4 style={{ fontSize: '32px' }} className="color-secondary" >
                                            OUR WINE BOTTLES ARE LIGHTER, SHORTER AND MADE FROM CLEAR GLASS FOR
                                            IMPROVED RECYCLABILITY AND A LOWER CARBON FOOTPRINT.
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mobile-show">
                            <div className="mb-3">
                                <img style={{ maxHeight: '240px' }} className="center" src="https://res.cloudinary.com/carbonclick/image/upload/v1613084275/Enterprise/Round%20Theory%20/rt-2_uqekuk.png" />
                            </div>

                            <div className="py-2 px-3 text-center">
                                <h4 style={{ fontSize: '24px' }} className="color-secondary" >
                                    OUR WINE BOTTLES ARE LIGHTER, SHORTER AND MADE FROM CLEAR GLASS FOR
                                    IMPROVED RECYCLABILITY AND A LOWER CARBON FOOTPRINT.
                                </h4>
                            </div>

                        </div>
                    </div>
                </article>
            </section>

            <section className="py-5 mobile-py-3" >
                <article className='container'>
                    <div className="mw-800px center">
                        <div className="mb-4">
                            <h3 className="font-bold color-primary">We support projects that make a real difference</h3>
                            <h4>Round Theory &amp; CarbonClick supports only the highest quality carbon offsetting projects around the world, to bring acountability and results. You can Track and Trace our impact.</h4>
                            <br />
                            <a className="btn btn-primary mb-3 mr-2" without rel="noopener noreferrer" href="https://my.carbon.click/transaction/238f3941-7656-49f2-84f6-711265ba4d1f" target="_blank">October 2020</a>
                            <a className="btn btn-primary mb-3" without rel="noopener noreferrer" href="https://my.carbon.click/transaction/fa5add12-8e39-4cf4-9d7a-ea180e9a2aa8" target="_blank">February 2021</a>
                        </div>

                        {fetchedImpact && fetchedImpact.projects ?
                            <div style={{ textAlign: "left" }}>

                                <ProjectsList projects={fetchedImpact.projects} numProjectsToShow={4} showLearnMore={false} /></div>
                            :
                            fetchedImpact && fetchedImpact.error ? <div style={{ paddingTop: 20 }}><div>Could not load projects, please try again later.</div></div> : null
                        }
                    </div>
                </article>
            </section>

            <div className="w-100 img-cover footer-img py-6" >
                <div className="container color-white py-5">
                    <p><b>Powered by</b></p>
                    <div className="d-flex">
                        <div>
                            <a href={"https://carbonclick.com"} target="_blank" rel="noopener noreferrer">
                                <img style={{ height: 30 }} className="footer-logo" src={logo} alt="carbonclick" />
                            </a>
                        </div>
                        <div className="right">
                            <div>
                                <a href={"https://www.facebook.com/CarbonClickCommunity/"} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30 }} src={facebook} alt="carbonclick" />
                                </a>
                                <a href={"https://www.instagram.com/carbon.click/"} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30 }} src={instagram} alt="carbonclick" />
                                </a>
                                <a href={"https://twitter.com/carbonclick"} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30 }} src={twitter} alt="carbonclick" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <hr className="mb-4" />

                    <div className="row">
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href={"https://carbonclick.com"} target="_blank" rel="noopener noreferrer">How it works</a></div>
                                <div className="mb-3"><a className="color-white" href={"https://www.carbonclick.com/about/"} target="_blank" rel="noopener noreferrer">About CarbonClick</a></div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href={"https://www.carbonclick.com/terms/"} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></div>
                                <div className="mb-3"><a className="color-white" href={"https://www.carbonclick.com/privacy-policy/"} target="_blank" rel="noopener noreferrer">Privacy policy</a></div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href={footerLinks.faq} target="_blank" rel="noopener noreferrer">FAQs</a></div>
                                <div className="mb-3"><a className="color-white" href="mailto:support@carbonclick.com" target="_blank" rel="noopener noreferrer">support@carbonclick.com</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default LearnMorePage;
